import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { deleteClosure } from '@/lib/venue/closureApi'
import type { VenueClosureListView } from '@/lib/venue/closureTypes'

import { venueClosuresQueryKey } from './useVenueClosures'

/**
 * 휴무·차단·레슨 해제 (#604).
 * 응답(= 해제 후 최신 목록)을 목록 쿼리 캐시에 **직접 반영**한다 — 재조회하지 않는다.
 */
export function useDeleteVenueClosure(venueId: string) {
  const queryClient = useQueryClient()

  return useMutation<VenueClosureListView, ApiError, number>({
    mutationFn: (closureId) => deleteClosure(venueId, closureId),
    onSuccess: (data) => {
      queryClient.setQueryData(venueClosuresQueryKey(venueId), data)
    },
  })
}
